/** The environment's own icon, copied to the site root per build configuration (see angular.json). */
export const DEFAULT_FAVICON_HREF = 'favicon.png';

// Safari ignores a changed href on an existing icon link, so the link is replaced instead.
export function setFavicon(doc: Document, href: string): void {
    const current = doc.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (current !== null && current.getAttribute('href') === href) {
        return;
    }
    const link = doc.createElement('link');
    link.rel = 'icon';
    link.href = href;
    if (current === null) {
        doc.head.appendChild(link);
    } else {
        current.replaceWith(link);
    }
}
